const DEFAULT_TIMEOUT_MS = 1000;
export const FAILSAFE_BUFFER_MS = 500;

function validateOpenxBids(adUnit) {
  const bids = (adUnit.bids || []).filter(bid => {
    if (bid.bidder !== 'openx') {
      return true;
    }
    const { unit, delDomain } = bid.params || {};
    if (typeof unit === 'string' && unit.trim() && typeof delDomain === 'string' && delDomain.trim()) {
      return true;
    }

    // eslint-disable-next-line no-console
    console.warn(`OpenX bidder skipped for slot "${adUnit.code}": unit and delDomain must be non-empty strings.`);
    return false;
  });
  return { ...adUnit, bids };
}

export function requestBidsAndSetTargeting({
  adUnits = [],
  timeoutMs = DEFAULT_TIMEOUT_MS,
  adUnitCodes = adUnits.map(adUnit => adUnit.code),
  registerAdUnits = true,
  isCurrent = () => true,
} = {}) {
  if (typeof window === 'undefined') {
    return Promise.resolve(false);
  }

  const pbjs = window.pbjs;
  if (!pbjs || !adUnitCodes.length) {
    return Promise.resolve(false);
  }

  pbjs.que = pbjs.que || [];

  return new Promise(resolve => {
    let settled = false;
    let failsafeTimer;
    const finish = result => {
      if (!settled) {
        settled = true;
        clearTimeout(failsafeTimer);
        resolve(result);
      }
    };
    failsafeTimer = setTimeout(() => finish(false), timeoutMs + FAILSAFE_BUFFER_MS);

    pbjs.que.push(() => {
      if (settled || !isCurrent()) {
        finish(false);
        return;
      }

      try {
        if (
          typeof pbjs.addAdUnits !== 'function' ||
          typeof pbjs.requestBids !== 'function' ||
          typeof pbjs.setTargetingForGPTAsync !== 'function'
        ) {
          finish(false);
          return;
        }

        // Refreshes reuse registered units; validate those too, immediately before bidding.
        const auctionAdUnits = (
          registerAdUnits ? adUnits : (pbjs.adUnits || []).filter(adUnit => adUnitCodes.includes(adUnit.code))
        ).map(validateOpenxBids);

        if (registerAdUnits && auctionAdUnits.length) {
          pbjs.removeAdUnit?.(adUnitCodes);
          pbjs.addAdUnits(auctionAdUnits);
        }

        pbjs.requestBids({
          ...(!registerAdUnits && auctionAdUnits.length ? { adUnits: auctionAdUnits } : {}),
          adUnitCodes,
          timeout: timeoutMs,
          bidsBackHandler: () => {
            if (settled || !isCurrent()) {
              finish(false);
              return;
            }
            try {
              pbjs.setTargetingForGPTAsync(adUnitCodes);
              finish(true);
            } catch {
              finish(false);
            }
          },
        });
      } catch {
        finish(false);
      }
    });
  });
}
